import { Subject } from 'rxjs';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CitiService } from '@sg/api/citi-service';
import { swiftStatusMapper, SWIFT_FORWARDING_INBOUND_COLUMNS } from '../../files-table/inspector-table-columns';

@Component({
  selector: 'sg-inspector-inbound',
  templateUrl: './inspector-inbound.component.html',
  styleUrls: ['./inspector-inbound.component.scss'],
  standalone: false,
})
export class SgInspectorInboundComponent {
  @Input() inboundTableData$: Subject<Array<CitiService.InboundFileDto>>;
  @Input() inboundFileContent$: Subject<string>;
  @Output() onClickClose = new EventEmitter<null>();
  @Output() onClickRestart = new EventEmitter<null>();
  @Output() onClickRow = new EventEmitter<string>();
  @Output() onClickDownloadFile = new EventEmitter<string>();
  inboundColumns = SWIFT_FORWARDING_INBOUND_COLUMNS;
  swiftStatusMapper = swiftStatusMapper;
}
